import axios from "axios";
import AuthService from "../utils/authService";
import * as constants from "../utils/constants";
import moment from "moment";
import { DateObject } from "@progress/kendo-dateinputs-common/dist/npm/common/dateobject";

const baseurl = constants.default.baseUrl;
const basehosturl = constants.default.baseHostUrl;

const RegisterAPI = {
  getRegister: async (str, clientId) => {
    let result = await axios.get(baseurl + "/api/register?" + str, {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });

    (result.data.data || []).forEach((item) => {
      item.dteSignIn =
        item.dteSignIn == null
          ? null
          : moment.utc(item.dteSignIn).local().format("DD-MMM-YYYY HH:mm");
      item.dteSignOut =
        item.dteSignOut == null
          ? null
          : moment.utc(item.dteSignOut).local().format("DD-MMM-YYYY HH:mm");
      item.creationDate =
        item.creationDate == null
          ? null
          : moment.utc(item.creationDate).local().format("DD-MMM-YYYY HH:mm");
    });

    return result;
  },

  getRegisterById: async (id) => {
    return await axios.get(baseurl + "/api/register/getRegisterById?id=" + id, {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  getRaceCard: (id) => {
    return axios.get(baseurl + "/api/raceCard?id=" + id, {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  getSignInLocation: (id) => {
    return axios.get(
      baseurl + "/api/registerLocation?includeAll=true&locationId=" + id,
      { headers: { Authorization: `Bearer ${AuthService.getToken()}` } },
    );
  },

  getPersonnel: (str) => {
    return axios.get(baseurl + "/api/personnel?" + str, {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  GetPersonnelSearchList: (name) => {
    return axios.get(
      baseurl +
        "/api/personnel/GetPersonnelSearchList?NamePartOrReference=" +
        encodeURIComponent(name),
      {
        headers: { Authorization: `Bearer ${AuthService.getToken()}` },
      },
    );
  },

  getPersonnelById: (id) => {
    return axios.get(
      baseurl + "/api/personnel/getPersonnelById?personnelId=" + id,
      {
        headers: { Authorization: `Bearer ${AuthService.getToken()}` },
      },
    );
  },

  getReferenceNumberCheck: (PersonnelId, ReferenceNumber) => {
    return axios.get(
      baseurl +
        "/api/personnel/IsReferenceNumberUsed?personnelId=" +
        PersonnelId +
        "&referenceNumber=" +
        ReferenceNumber,
      { headers: { Authorization: `Bearer ${AuthService.getToken()}` } },
    );
  },

  findByReferenceNumber: (ReferenceNumber) => {
    return axios.get(
      baseurl +
        "/api/personnel/FindByReferenceNumber?referenceNumber=" +
        ReferenceNumber,
      { headers: { Authorization: `Bearer ${AuthService.getToken()}` } },
    );
  },

  getPersonnelByCardId: (id) => {
    return axios.get(
      baseurl + "/api/personnel/getPersonnelByCard?cardId=" + id,
      { headers: { Authorization: `Bearer ${AuthService.getToken()}` } },
    );
  },

  getLocation: (include) => {
    return axios.get(baseurl + "/api/registerLocation?includeAll=" + include, {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  getPostcode: (origin, destination) => {
    return axios.get(
      baseurl +
        "/api/postcode/getPostcode?origin=" +
        origin +
        "&destination=" +
        destination,
      { headers: { Authorization: `Bearer ${AuthService.getToken()}` } },
    );
  },

  getPostcodes: () => {
    return axios.get(baseurl + "/api/postcode", {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  getTravelTime: (origin, destination) => {
    return axios.get(
      baseurl +
        "/api/travelTime/getTravelTime?origin=" +
        origin +
        "&destination=" +
        destination,
      { headers: { Authorization: `Bearer ${AuthService.getToken()}` } },
    );
  },

  getRegisterHistory: (str) => {
    return axios.get(baseurl + "/api/registerHistory?" + str, {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  getRegisterWeeklyHistory: () => {
    return axios.get(
      baseurl + "/api/registerHistory/getRegisterWeeklyHistory",
      {
        headers: { Authorization: `Bearer ${AuthService.getToken()}` },
      },
    );
  },

  getRegisterCount: () => {
    return axios.get(baseurl + "/api/register/getActiveCount", {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  GetSignInHistory: (registerId) => {
    return axios.get(
      baseurl +
        "/api/registerHistory/GetSignInHistory?registerId=" +
        registerId,
      { headers: { Authorization: `Bearer ${AuthService.getToken()}` } },
    );
  },

  getSignInPersonnel: (name, cardId) => {
    return axios.get(
      baseurl +
        "/api/register/getSignInPersonnel?NameAndCompanyOrReference=" +
        encodeURIComponent(name) +
        "&CardId=" +
        cardId,
      { headers: { Authorization: `Bearer ${AuthService.getToken()}` } },
    );
  },

  getFieldSchema: (path) => {
    return axios.get(baseurl + "/api/fieldSchema?path=" + path, {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  getRegisterLogs: (str) => {
    return axios.get(baseurl + "/api/registerlog?" + str, {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  getRegisterLogById: (registerlogid) => {
    return axios.get(
      baseurl +
        "/api/registerLog/getRegisterLogById?projectid=0&registerlogid=" +
        registerlogid,
      { headers: { Authorization: `Bearer ${AuthService.getToken()}` } },
    );
  },

  getCollars: () => {
    return axios.get(baseurl + "/api/collar?id=0", {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  getBriefingTemplates: () => {
    return axios.get(baseurl + "/api/BriefingTemplate", {
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  saveSignInLocation: (obj) => {
    return axios({
      method: "post",
      url: baseurl + "/api/registerLocation",
      data: obj,
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  deleteSignInLocation: (id) => {
    return axios.delete(baseurl + "/api/registerLocation", {
      params: { id: id },
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  saveRegisterLog: (obj) => {
    return axios({
      method: "post",
      url: baseurl + "/api/registerLog",
      data: obj,
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  deleteRegister: (id) => {
    return axios.delete(baseurl + "/api/register", {
      params: { id: id },
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  deletePersonnel: (id) => {
    return axios.delete(baseurl + "/api/personnel", {
      params: { id: id },
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  deleteRegisterLog: (id) => {
    return axios.delete(baseurl + "/api/registerLog", {
      params: { id: id },
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  saveRegisterAccident: (obj) => {
    return axios({
      method: "post",
      url: baseurl + "/api/registerAccident",
      data: obj,
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  deleteRegisterAccident: (id) => {
    return axios.delete(baseurl + "/api/registerAccident", {
      params: { id: id },
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  deleteRegisterFile: (id) => {
    return axios.delete(baseurl + "/api/docFile", {
      params: { id: id },
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  saveRegister: (obj, action) => {
    return axios({
      method: "post",
      url: baseurl + "/api/register?action=" + action,
      data: obj,
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  saveRegisterAll: (obj, action) => {
    console.log(obj);
    return axios({
      method: "post",
      url: baseurl + "/api/register/saveAll?action=" + action,
      data: obj,
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },

  savePersonnel: (obj, action) => {
    return axios({
      method: "post",
      url: baseurl + "/api/personnel",
      data: obj,
      headers: { Authorization: `Bearer ${AuthService.getToken()}` },
    });
  },
};

export default RegisterAPI;
